import { render, staticRenderFns } from "./CollectionList.vue?vue&type=template&id=46cc072d&scoped=true&"
import script from "./CollectionList.vue?vue&type=script&lang=js&"
export * from "./CollectionList.vue?vue&type=script&lang=js&"
import style0 from "./CollectionList.vue?vue&type=style&index=0&id=46cc072d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc072d",
  null
  
)

export default component.exports